export const RECEIVE_USER = 'RECEIVE_USER'
export const RECEIVE_USER_REVIEWS = 'RECEIVE_USER_REVIEWS'
export const LOGOUT = 'LOGOUT'
export const RECEIVE_AUTH_ERROR = 'RECEIVE_AUTH_ERROR'
export const RECEIVE_RANDOM_ITEM = 'RECEIVE_RANDOM_ITEM'
